import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/containers')({
  staticData: { breadcrumb: 'Container Library' },
  component: () => <Outlet />,
});
